export enum MessageType {
  GENERAL_MESSAGE = 'General Message',
  CASE_MESSAGE = 'Case Message',
  CLIENT_CASE_SURVEY = 'Client Case Survey',
  CLIENT_UPDATE = 'Client Update',
  SURVEY = 'Survey',
  /** An internal note. Audience is the authoring firm only, and notes never affect unread state. */
  NOTE = 'Note'
}
